import { Image, Typography } from "antd";
import React from "react";
import { Link, useHistory } from "react-router-dom";

interface Props {
  image: any;
  title: any;
  desc: any;
  labelName: any;
  productId: any;
  artistName?: any;
  stockDescription?: any;
  catNo: any;
  productType?: any;
  productReleaseEnumValue?: any;
  title1?: any;
  forthComing?: any;
  isRsdSpecial?: any;
}

const Releases = (props: Props) => {
  // console.log("props", props)
  const history = useHistory();
  const handleClickNavigation = (): void => {
    history.push(`/products/${props.productType}/${props.catNo}`);
  };

  return (
    <Link to={`/products/${props.productType}/${props.catNo}`}>
      {/* <div onClick={handleClickNavigation}> */}
        <Image
          preview={false}
          src={props?.image}
          onError={(e: any) =>
            (e.target.src =
              props?.title1 === "yes"
                ? "/default_image.png"
                : "default_image.png")
          }
          //  onError={"https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50"}
        />
        {props.forthComing && (
          <Typography.Title className="forthComing" level={4}>
            {props.forthComing ? "FORTHCOMING" : ""}
          </Typography.Title>
        )}

        {props.isRsdSpecial && (
          <Typography.Title className="forthComing" level={4}>
            {props.isRsdSpecial ? "RSD RELEASE" : ""}
          </Typography.Title>
        )}

        <Typography.Title
          className={
            props.forthComing || props.isRsdSpecial ? "forthComing-title" : ""
          }
          level={3}
        >
          {props.artistName}
        </Typography.Title>
        <Typography.Title level={4}>{props.title}</Typography.Title>
        <Typography.Title level={4}>{props.catNo}</Typography.Title>
        <Typography.Title level={4}>{props.labelName}</Typography.Title>
        {props.stockDescription && props.stockDescription}
      {/* </div> */}
    </Link>
  );
};

export default React.memo(Releases);
